import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

export const adminApi = (token) =>
  axios.create({
    baseURL: API_BASE,
    headers: { "Content-Type": "application/json", "X-Admin-Token": token },
  });

export const currency = (v) => {
  if (v == null || Number.isNaN(v)) return "—";
  return new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
    maximumFractionDigits: 0,
  }).format(v);
};

export const percent = (v) => {
  if (v == null || Number.isNaN(v)) return "—";
  return `${(v * 100).toFixed(1)}%`;
};

export const multiple = (v) => {
  if (v == null || Number.isNaN(v)) return "—";
  return `${v.toFixed(2)}×`;
};
